import { render, staticRenderFns } from "./Commande.vue?vue&type=template&id=1817b23e&scoped=true&"
import script from "./Commande.vue?vue&type=script&lang=js&"
export * from "./Commande.vue?vue&type=script&lang=js&"
import style0 from "./Commande.vue?vue&type=style&index=0&id=1817b23e&lang=scss&scoped=true&"
import style1 from "./Commande.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1817b23e",
  null
  
)

export default component.exports